// Tiny localStorage helper for the user's last known location.
// Format:
//   { plz, lat, lng, displayName, city, state, source, savedAt }

const KEY = "notfall.location";

export const loadLocation = () => {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (typeof parsed?.lat !== "number" || typeof parsed?.lng !== "number") {
            return null;
        }
        return parsed;
    } catch {
        return null;
    }
};

export const saveLocation = (loc) => {
    if (!loc || typeof loc.lat !== "number" || typeof loc.lng !== "number") return;
    try {
        const payload = { ...loc, savedAt: Date.now() };
        localStorage.setItem(KEY, JSON.stringify(payload));
    } catch {
        /* noop */
    }
};

export const clearLocation = () => {
    try {
        localStorage.removeItem(KEY);
    } catch {
        /* noop */
    }
};

export const formatLocationLabel = (loc) => {
    if (!loc) return "";
    if (loc.displayName) {
        // Trim long Nominatim strings: "Street, City, ..., Germany" → "Street, City"
        const parts = loc.displayName.split(",").map((p) => p.trim()).filter(Boolean);
        if (parts.length <= 2) return parts.join(", ");
        return `${parts[0]}, ${parts[parts.length - 3] || parts[1]}`;
    }
    if (loc.city && loc.plz) return `${loc.plz} ${loc.city}`;
    if (loc.plz) return loc.plz;
    if (loc.city) return loc.city;
    return `${loc.lat.toFixed(4)}, ${loc.lng.toFixed(4)}`;
};
